module.exports = __webpack_public_path__ + "media/images/common/ico-like-4e6a057b66e898a2ab427567e965d05e.svg";